{
  "navigation": {
    "current": "Actual",
    "schedule": "Programación",
    "tenants": "Inquilinos",
    "opsCenter": "Centro Ops",
    "hangars": "Hangares",
    "ramps": "Rampas",
    "aircraft": "Aeronave",
    "tripSchedule": "Programación viaje",
    "ops": "Ops",
    "feeCalculator": "Calculador de tarifas",
    "hangarOptimization": "Calculador de optimización de hangar",
    "help": "Ayuda",
    "superAdmin": "Superadmin",
    "settings": "Ajustes",
    "logout": "Salir",
    "logoAlt": "Logo de AirPLX"
  },
  "timeControl": {
    "prevTrip": "Viaje ant.",
    "nextTrip": "Próximo viaje",
    "now": "Ahora",
    "today": "Hoy",
    "daily": "Diario",
    "15m": "15m",
    "previousDay": "Día anterior",
    "nextDay": "Día siguiente",
    "viewSchedule": "Ver programación",
    "timeSelectionAriaLabel": "Selector de hora",
    "tripDurationTitle": "Duración del viaje de la aeronave seleccionada",
    "noPreviousTrips": "No hay viajes anteriores",
    "noPreviousTripsForAircraft": "No hay viajes anteriores para {{tailNumber}}",
    "jumpToPreviousTrip": "Ir al viaje anterior",
    "jumpToPreviousTripForAircraft": "Ir al viaje anterior de {{tailNumber}}",
    "noFutureTrips": "Sin viajes programados",
    "noFutureTripsForAircraft": "No hay viajes programados para {{tailNumber}}",
    "jumpToNextTrip": "Ir al siguiente viaje",
    "jumpToNextTripForAircraft": "Ir al siguiente viaje de {{tailNumber}}"
  },
  "tripListDisplay": {
    "noTripsFound": "Sin viajes",
    "noOwner": "Sin dueño"
  },
  "bulkApplyFloatingAction": {
    "applyButton": "Aplicar",
    "message": "Aplicar acción flotante en lote"
  },
  "dimensionInput": {
    "currentPrefix": "Actual:",
    "errorMessage": "Dimensión no válida",
    "unit": "ft"
  },
  "equipmentTable": {
    "nameHeader": "Nombre",
    "lengthHeader": "Longitud",
    "widthHeader": "Ancho",
    "heightHeader": "Altura",
    "towBarHeader": "Barra de remolque",
    "actionsHeader": "Acciones",
    "editButton": "Editar",
    "deleteButton": "Eliminar"
  },
  "obstaclePreview": {
    "title": "Previa de obstáculo",
    "emptyState": "Selecciona un obstáculo para previsualizar",
    "noImageAvailable": "Sin imagen disponible",
    "dimensionsLabel": "Dimensiones",
    "lengthLabel": "Longitud",
    "widthLabel": "Ancho",
    "heightLabel": "Altura",
    "unit": "ft"
  },
  "obstacleTable": {
    "nameHeader": "Nombre",
    "lengthHeader": "Longitud",
    "widthHeader": "Ancho",
    "heightHeader": "Altura",
    "actionsHeader": "Acciones",
    "editButton": "Editar",
    "deleteButton": "Eliminar"
  },
  "recentPatternsPanel": {
    "title": "Patrones recientes",
    "lastPrefix": "Último:",
    "appliedSuffix": "aplicado",
    "never": "Nunca",
    "reApplyButton": "Reaplicar",
    "unknownAircraft": "Aeronave desconocida"
  },
  "vipTagSelect": {
    "label": "Tags",
    "addTag": "Añadir",
    "editTags": "Editar tags",
    "noTags": "Sin tags"
  },
  "notFoundCard": {
    "hangarTitle": "Hangar no encontrado",
    "rampTitle": "Rampa no encontrada",
    "hangarMessage": "El hangar que busca no existe o ya no tiene acceso.",
    "rampMessage": "La rampa que busca no existe o ya no tiene acceso.",
    "goToHangars": "Ir a hangares",
    "goToRamps": "Ir a rampas"
  },
  "activation": {
    "title": "Responde una pregunta real sobre hangar",
    "subtitle": "5 pasos para ser un experto en AirPlx",
    "steps": {
      "addAircraft": {
        "title": "Añadir otra aeronave",
        "description": "Añadir un arrendatario a tu hangar"
      },
      "firstAutostack": {
        "title": "Ejecutar AutoStack",
        "description": "Deja que el algoritmo organice tus aeronaves"
      },
      "secondAutostack": {
        "title": "Probar otro escenario",
        "description": "Ejecutar AutoStack de nuevo con otra aeronave"
      },
      "saveFavorite": {
        "title": "Guardar este diseño",
        "description": "Crear un favorito para consultar después"
      },
      "shareLayout": {
        "title": "Compartir con tu equipo",
        "description": "Imprimir, copiar enlace o enviar por correo"
      },
      "runAutostack": "Continuar"
    },
    "progress": "{{completed}} de {{total}} completados",
    "dismiss": "Descartar por ahora",
    "completed": "Completado",
    "complete": {
      "title": "¡Todo listo!",
      "message": "Has completado la configuración. AirPlx está listo para ayudarte a planificar.",
      "dismiss": "Entendido"
    }
  }
}
